export enum ReminderIntervals {
  None = 0,
  FiveMinutes = 1,
}
